import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "mt-2",
  style: {"position":"relative","margin-top":"10px","width":"100%"}
}
const _hoisted_2 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2 color-block" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"block"} }, null, -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "material-symbols-outlined",
  style: {"font-size":"12pt","padding":"5px"}
}, "refresh", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  class: "colorPick"
}
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_imdex_tooltip, {
        style: {"margin-right":"10px"},
        top: ""
      }, {
        activator: _withCtx((on) => [
          _createElementVNode("div", null, [
            _createVNode(_component_imdex_btn, _mergeProps({ disabled: _ctx.isLoading }, _toHandlers(on), {
              mini: "",
              text: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAllOpacity(_ctx.idx)))
            }), {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa", {
									'fa-eye': _ctx.isAllCategoriesVisible,
									'fa-eye-slash': !_ctx.isAllCategoriesVisible
								}])
                }, null, 2)
              ]),
              _: 2
            }, 1040, ["disabled"])
          ])
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("span", {
            innerHTML: _ctx.$t(`ssa.displayPane.indexedColors.toggleAllVisTooltip`)
          }, null, 8, _hoisted_5)
        ]),
        _: 1
      }),
      _createVNode(_component_imdex_tooltip, { top: "" }, {
        activator: _withCtx((on) => [
          _createElementVNode("span", _toHandlers(on), _toDisplayString(_ctx.indexedOpacities?.length), 17)
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("span", {
            innerHTML: _ctx.$t(`ssa.displayPane.indexedColors.totalCategoriesCountTooltip`)
          }, null, 8, _hoisted_6)
        ]),
        _: 1
      }),
      _createVNode(_component_imdex_tooltip, {
        style: {"margin-left":"auto"},
        top: ""
      }, {
        activator: _withCtx((on) => [
          _createVNode(_component_imdex_btn, _mergeProps(_toHandlers(on), {
            mini: "",
            text: "",
            fab: "",
            onClick: _ctx.refreshCategories,
            disabled: _ctx.isLoading,
            style: {"top":"-5px","display":"block","right":"0px","z-index":"10"}
          }), {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 2
          }, 1040, ["onClick", "disabled"])
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("span", {
            innerHTML: _ctx.$t(`ssa.displayPane.indexedColors.refCatList`)
          }, null, 8, _hoisted_8)
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "fadeInUp",
      "leave-active-class": "fadeOutDown"
    }, {
      default: _withCtx(() => [
        (_ctx.colorOpen)
          ? (_openBlock(), _createBlock(_component_ColorPicker, {
              key: 0,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.colorOpen = false)),
              color: _ctx.activeColorComputed,
              onChange: _ctx.updateColor,
              ref: "colorPicker"
            }, null, 8, ["color", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discreteColors, (entry, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        ref_for: true,
        ref: `ref${idx}`,
        class: "color-item"
      }, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.toggleColorOpen(idx, `ref${idx}`)), ["prevent"]),
              style: _normalizeStyle({ background: entry.hex }),
              class: "mr-2 color-block"
            }, null, 12, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: _normalizeStyle({
					background: entry.hex,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}),
              class: "mr-2 color-block"
            }, [
              _createVNode(_component_imdex_spinner, {
                size: "1",
                width: "30"
              })
            ], 4)),
        (_ctx.colorPickerIndex == idx && _ctx.colorOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10))
          : _createCommentVNode("", true),
        _createVNode(_component_imdex_btn, {
          disabled: _ctx.isLoading,
          mini: "",
          text: "",
          onClick: ($event: any) => (_ctx.toggleOpacity(idx))
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["fa", { 'fa-eye': entry.opacity, 'fa-eye-slash': !entry.opacity }])
            }, null, 2)
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"]),
        _createVNode(_component_imdex_tooltip, { style: {"max-width":"calc(100% - 55px)"} }, {
          activator: _withCtx((on) => [
            _createElementVNode("div", _mergeProps(_toHandlers(on), {
              class: "color-title",
              style: {"display":"block","text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap","padding-right":"20px"}
            }), _toDisplayString(entry.label), 17)
          ]),
          tooltip: _withCtx(() => [
            _createElementVNode("span", {
              innerHTML: entry.label
            }, null, 8, _hoisted_11)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}